<ul class="filters-subsection">
    <li *ngFor="let group of labelsGroups | sortBy: 'id' : 'asc'" (click)="onOpen($event,group)" [ngClass]="{opened: opened == group.id}">
        <!-- gorups component -->
        <span class="filter-subtitle"><em>{{group.name}}</em></span>
        <app-helpers-search-filters-labels-group
            [hidden]="opened != group.id"
            [labels]="getGroupLabels(group)"
            [selecteds]="selecteds"
            (choose)="onSelect($event)"
        ></app-helpers-search-filters-labels-group>
    </li>
</ul>
